export default __webpack_public_path__ + "static/media/kaufman.c538db5a.jpg";